import {NgModule} from "@angular/core";
import {PageAccessibleService} from "./page-accessible.service";
import {DateFormatService} from "./date-format.service";
import {ShowConditionService} from "./show-condition.service";
import {FilterDataService} from "./filter-data.service";
import {ShowConditionV2Service} from "./show-condition-v2.service";
import {AccessDataService} from "../data/access-data.service";
import {AppPageApi2} from "../api/app-page.api";
import { AlertMessageService } from './alert-message.service';

@NgModule({
  providers: [
    PageAccessibleService,
    DateFormatService,
    ShowConditionService,
    FilterDataService,
    ShowConditionV2Service,
    AlertMessageService,
    AccessDataService,
    AppPageApi2
  ]
})
export class HelperModule {
}



// WEBPACK FOOTER //
// ./src/pagebuilder/services/helper/helper.module.ts